module.exports = __webpack_public_path__ + "static/img/B高清显示.5ebd575.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/type1-1/fit/B高清显示.png
// module id = GPwl
// module chunks = 0